'use client';

import { Toaster } from "react-hot-toast";

export const ToasterProvider = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={true}
      toastOptions={{
        success: {
          style: {
            background: "linear-gradient(90deg, #CDEBDB 0%, #F0F0F0 100%)",

            color: "black",
            fontWeight: "600",
          },
        },
        error: {
          style: {
            background:
              "linear-gradient(90.05deg, #FADCDC 0.04%, #F8EAEA 97.58%)",

            color: "black",
            fontWeight: "600",
          },
        },
      }}
    />
  )
}
